<template>
	<div class="devider" :style="{ margin }" />
</template>

<script>
export default {
	props: {
		margin: {
			type: String,
			default: '15px 0',
		},
	},
}
</script>

<style lang="less" scoped>
@import '../../assets/app.less';

.devider {
	width: 100%;
	height: 2px;
	background: @grey;
}
</style>
